import React from 'react';

const SubNavCompact = ({ subNavigation }) => (
  <nav className="subnav subnav--compact" role="navigation">
    {displaySubNav(subNavigation, true)}
  </nav>
);

const displaySubNav = (subnav, isBold = false) =>
  subnav && (
    <ul className="subnav__list [&_ul]:pl-4">
      {subnav.map(({ name, url, links }, index) => (
        <li
          className={`subnav__item py-2 ${
            links && links.length > 0 ? 'has-children' : ''
          } ${isBold ? 'bold' : ''}`}
          key={`subnavCompact-${index}`}
        >
          <a className={`subnav__link ${isBold ? 'font-bold': 'font-normal'}`} href={url}>
            {name}
          </a>
          {displaySubNav(links)}
        </li>
      ))}
    </ul>
  );

export default SubNavCompact;
